import React from "react";
import { ArrowRight, Check } from "lucide-react";

const GOLD = "#D49B3C";
const GOLD_DARK = "#A9712A";

/**
 * Promise-led opener for paid (Google Ads) visitors — replaces the
 * countdown + pick-first contest header. One Start button; the persona
 * cards and contest render below it as an optional extra.
 */
export const PaidIntro = ({ onStart }) => (
  <div data-testid="quiz-paid-intro">
    <span
      className="inline-block px-4 py-1.5 rounded-full text-[11px] font-semibold tracking-widest uppercase"
      style={{ background: "#FAEACB", color: GOLD_DARK }}
      data-testid="quiz-intro-eyebrow"
    >
      The MoneyMind Quiz&trade; &middot; Free
    </span>
    <h1
      className="font-serif text-3xl sm:text-4xl mt-5 text-[#1B2A3A] leading-tight"
      data-testid="quiz-intro-title"
    >
      Why your last budget didn&apos;t stick.
    </h1>
    <p className="mt-3 text-sm sm:text-base text-[#4d4f4c] max-w-lg mx-auto">
      20 questions, about 5 minutes. Find your MoneyMind type &mdash; then use the
      full app <strong>60 days free</strong>. No credit card.
    </p>
    <button
      type="button"
      onClick={onStart}
      className="mt-6 inline-flex items-center gap-2 px-8 py-3.5 rounded-full font-semibold text-base transition-opacity hover:opacity-90"
      style={{ background: GOLD, color: "#2A1A05" }}
      data-testid="quiz-paid-start"
    >
      Start the free quiz
      <ArrowRight className="h-4 w-4" />
    </button>
    <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5 text-xs text-[#4d4f4c]" data-testid="quiz-paid-trial-line">
      {["Free quiz", "60 days of the full app free", "No card, nothing to cancel"].map((t) => (
        <li key={t} className="inline-flex items-center gap-1.5">
          <Check className="h-3.5 w-3.5" style={{ color: GOLD }} /> {t}
        </li>
      ))}
    </ul>
    <p className="mt-8 text-xs font-semibold tracking-widest uppercase text-[#9b9892]">
      Optional &middot; monthly contest
    </p>
    <p className="mt-1 text-sm text-[#4d4f4c]">
      Think you already know your type? Pick it and start with a guess.
    </p>
  </div>
);
